import React from "react";
import { useWhisper } from "@chengsokdara/use-whisper";

const Test = () => {
  const avatarlanguage = sessionStorage.getItem("language");
  const languageCode = avatarlanguage === "English" ? "en" : "id";
  const {
    transcript,
    recording,
    pauseRecording,
    startRecording,
    stopRecording,
  } = useWhisper({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY,
    streaming: true,
    timeSlice: 1_000, // 1 sec
    whisperConfig: {
      language: languageCode,
    },
    removeSilence: true, // to save cost
    nonStop: true,
    stopTimeout: 10000, // stop recording after 10 sec of silence
  });

  console.log("Recording:", recording);

  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "1rem",
      }}
    >
      <p
        style={{
          marginBottom: "1rem",
        }}
      >
        Transcribed Text: {transcript.text}
      </p>
      <button onClick={() => startRecording()}>Start</button>
      <button onClick={() => pauseRecording()}>Pause</button>
      <button onClick={() => stopRecording()}>Stop</button>
    </div>
  );
};

export default Test;
